var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_36980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6557 49.0415L26.7372 27.2861",
    stroke: "url(#paint0_linear_98_36980)",
    strokeWidth: 17.0084,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M19.2717 45.0213L28.8198 34.043",
    stroke: "url(#paint1_linear_98_36980)",
    strokeWidth: 17.0084,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2441 41.0152L37.431 33.0811",
    stroke: "url(#paint2_linear_98_36980)",
    strokeWidth: 17.0084,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4826 11.332C27.2213 9.99224 29.3084 9.17119 31.7832 9.70638C32.9551 9.96249 33.8475 10.5596 34.3334 11.6448C34.6502 12.3445 34.953 12.4484 35.6944 12.1714C38.0534 11.2454 39.461 12.0852 39.6787 14.4119C39.808 15.8924 39.3782 16.2239 37.7495 16.2607C33.2356 16.3686 28.71 16.2539 24.1835 16.2409C20.9405 16.2322 17.6917 16.2565 14.4516 16.2314C13.6936 16.2173 12.9029 16.1975 12.193 16.0053C11.4204 15.7853 11.0121 15.2221 11.2033 14.3233C11.6319 12.2624 13.0475 10.9339 14.466 9.58885C16.4116 7.74286 21.3301 7.06175 23.12 8.61275C24.0029 9.36071 24.67 10.376 25.4826 11.332Z",
    fill: "url(#paint3_linear_98_36980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0986 44.9717C40.8372 43.6319 42.9244 42.8108 45.3992 43.346C46.571 43.6021 47.4635 44.1992 47.9493 45.2845C48.2661 45.9841 48.569 46.088 49.3104 45.811C51.6694 44.885 53.0769 45.7249 53.2946 48.0515C53.424 49.532 52.9941 49.8636 51.3654 49.9004C46.8516 50.0082 42.3259 49.8936 37.7994 49.8805C34.5564 49.8719 31.3077 49.8962 28.0676 49.8711C27.3096 49.857 26.5188 49.8371 25.809 49.645C25.0364 49.4249 24.6281 48.8618 24.8193 47.9629C25.2479 45.9021 26.6635 44.5735 28.082 43.2285C30.0275 41.3825 34.946 40.7014 36.736 42.2524C37.6189 43.0004 38.286 44.0156 39.0986 44.9717Z",
    fill: "url(#paint4_linear_98_36980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3623 21.7456L25.408 26.7838L25.0015 27.4181L17.5943 22.7797C17.2428 22.5595 17.1385 22.0948 17.3623 21.7456Z",
    fill: "url(#paint5_linear_98_36980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9822 37.7702L29.175 30.1738L37.4619 28.416L27.9822 37.7702Z",
    fill: "#F6AD20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8761 26.9025L26.7595 36.7682C26.7601 36.9648 26.8223 37.1562 26.9375 37.3155C27.0527 37.4749 27.215 37.594 27.4015 37.6561C27.5881 37.7183 27.7894 37.7203 27.9771 37.6618C28.1648 37.6034 28.3295 37.4876 28.4478 37.3306L31.3836 30.9064L32.8527 30.1537L48.7592 7.66336L49.0551 5.91406L46.4706 7.3428L24.8708 26.0935L24.8761 26.9025Z",
    fill: "url(#paint6_linear_98_36980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0918 5.76465C48.0494 5.7811 17.9311 20.9029 17.8902 20.9233C17.7409 20.9983 17.6143 21.1117 17.5234 21.252C17.4326 21.3922 17.3808 21.5541 17.3735 21.721C17.3661 21.8879 17.4034 22.0538 17.4815 22.2014C17.5596 22.3491 17.6757 22.4733 17.8179 22.5611L24.8759 26.9055L49.0548 5.91708C48.9254 5.80271 48.7661 5.72762 48.5955 5.70062C48.4249 5.67362 48.2502 5.69583 48.0918 5.76465Z",
    fill: "url(#paint7_linear_98_36980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0551 37.578L31.6811 30.5743L31.2909 31.2187L42.0234 37.8274C42.3769 38.045 42.84 37.9331 43.0551 37.578Z",
    fill: "url(#paint8_linear_98_36980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0876 5.96112C49.074 5.94794 49.0696 5.92747 49.0553 5.91504L48.8717 6.1752L31.3838 30.9069L42.207 37.5673C42.3366 37.647 42.4836 37.6939 42.6354 37.7041C42.7871 37.7144 42.9391 37.6875 43.0782 37.626C43.2172 37.5644 43.3393 37.4699 43.4337 37.3507C43.5282 37.2315 43.5923 37.0911 43.6204 36.9417L49.3747 6.80086C49.4003 6.64805 49.3874 6.49128 49.3373 6.34468C49.2872 6.19808 49.2014 6.06626 49.0876 5.96112Z",
    fill: "url(#paint9_linear_98_36980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5605 31.1158L49.1389 6.44336",
    stroke: "url(#paint10_linear_98_36980)",
    strokeWidth: 2.93248,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_36980",
    x1: 35.9778,
    y1: 13.1597,
    x2: 8.53923,
    y2: 56.4005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_98_36980",
    x1: 38.0601,
    y1: 19.9166,
    x2: 10.6216,
    y2: 63.1573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_98_36980",
    x1: 35.3374,
    y1: 31.0362,
    x2: 29.2035,
    y2: 40.8501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD45",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_98_36980",
    x1: 26.4927,
    y1: 8.76316,
    x2: 25.6794,
    y2: 33.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDE80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEBAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_98_36980",
    x1: 27.7618,
    y1: 40.6906,
    x2: 27.2812,
    y2: 53.1853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD57A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_98_36980",
    x1: 14.6728,
    y1: 18.3085,
    x2: 25.4082,
    y2: 28.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB13D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_98_36980",
    x1: 35.7666,
    y1: 37.707,
    x2: 36.9594,
    y2: 5.94043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAA34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_98_36980",
    x1: 33.2137,
    y1: 5.68945,
    x2: 33.2137,
    y2: 26.9055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC836"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_98_36980",
    x1: 48.7599,
    y1: 39.346,
    x2: 29.3242,
    y2: 33.4399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB13D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_98_36980",
    x1: 40.3857,
    y1: 5.91504,
    x2: 40.3857,
    y2: 37.7063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_98_36980",
    x1: 46.7532,
    y1: 4.74831,
    x2: 35.5157,
    y2: 37.9588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE083",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_36980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.09c849bb8214e365864ec0394bffddb5.svg";
export { ForwardRef as ReactComponent };